import { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom";
import { BuyTickets, GetEventByID } from "../../../../controllers/customer/EventosController";
import { Box, Button, Container, Divider, Fab, Grid, IconButton, MenuItem, Paper, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { imagesURL, stripePromisePK } from "../../../../apiRoutes/apiBase";
import QUDProgress from "../../../../components/progress";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faDirections, faMinusCircle, faPhone, faPlusCircle, faTicket, faTicketAlt } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

import {Elements, useElements, useStripe } from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import UserContext from "../../../../navigation/context/userContext";

import Payments from "../../../../components/Payments";
import ResponseComponent from "../../../../components/responseComponent";
import CountdownComponent from "../../../../components/CountDownComponent";

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

import { SeatsioSeatingChart } from '@seatsio/seatsio-react';
import ReCaptchaGoogle from "../../../../components/ReCaptchaGoogle";

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker, DateTimePicker, DesktopDatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import moment from "moment";

import logoDigitel from '../../../../assets/images/allies/logoDigitel.svg';

const stripePromise = loadStripe(stripePromisePK);


export default function Digitel()
{
    const { userData } = useContext(UserContext);
    const [showModal,setShowModal] = useState(true);

    const [event,setEvent] = useState([]);
    const [tickets,setTickets] = useState([]);

    const [sections,setSections] = useState([]);
    const [categories,setCategories] = useState([]);
    
    const [continuar,setContinuar] = useState(false);
    const [total,setTotal] = useState(100);
    const [subtotal,setSubTotal] = useState(0);
    const [comision,setComision] = useState(0);
    const [feeSeats,setFeeSeats] = useState(0);
    const [fee,setFee] = useState(0);

    /**customer data */
    const [name,setName] = useState('');
    const [nameError,setNameError] = useState(false);
    const [lastName,setLastName] = useState('');
    const [lastNameError,setLastNameError] = useState(false);
    const [birthDate,setBirthDate] = useState(new Date());
    const [documentType,setDocumentType] = useState('V');
    const [document,setDocument] = useState('');
    const [email,setEmail] = useState('');
    const [emailError,setEmailError] = useState(false);
    const [documentError,setDocumentError] = useState(false);
    const [prefix,setPrefix] = useState('');
    const [phoneNumber,setPhoneNumber] = useState('');
    const [phoneNumberError,setPhoneNumberError] = useState(false);
    const [address,setAddress] = useState('');
    const [profession,setProfession] = useState('');
    const [especialista,setEspecialista] = useState('');
    const [professionError,setProfessionError] = useState(false);

    const [activeStep,setActiveStep] = useState(0);
    const [showPaymentsForm,setShowPaymentsForm] = useState(false);

    const [isLoading,setIsLoading] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(true);
    const [successA,setSuccessA] = useState(false);
    const [show,setShow] = useState(false);
    const [actionText,setActionText] = useState('Finalizar');
    const [secondaryText,setSecondaryText] = useState('SI');
    const [goBack,setGoBack] = useState(false);

    const [complete,setComplete] = useState(false);

    const [clientSecret,setClientSecret] = useState('');

    const [selectedSeats,setSelectedSeats] = useState([]);
    const [holdToken,setHoldToken] = useState('');

    const [reCaptcha,setReCaptcha] = useState('');

    const { id } = useParams();

    const history = useHistory();

    const redireccionar = (route) => {
        history.push(route)
    }

    const options = {
        // passing the client secret obtained from the server
        //clientSecret: clientSecret?.client_secret,
        mode:'payment',
        currency:'usd',
        amount: 100,
        paymentMethodTypes:['card']
    };

    useEffect(()=>{
        handleGetEvent();
        if(userData.user !== undefined)
        {
            setName(userData.entity.name);
            setLastName(userData.entity.last_name);
            setDocumentType(userData.entity.document_type);
            setDocument(userData.entity.document_number);
            setPrefix(userData.user.prefijo);
            setPhoneNumber(userData.entity.phone);
            setEmail(userData.user.email);
        }
        window.scrollTo(0,0);
    },[]);

    /*useEffect(()=>{
        calculateUser()
     },[userData]);

     //verificar si el usuario esta logeado
    const calculateUser = () => {
        if(userData.user === undefined)
        {
            setShowModal(true);
        }
        else
        handleOnClose()
    }*/

    const handleGetEvent = async () => {
        setIsLoading(true);
        let response = await GetEventByID(id);
        if(response.success === true)
        {
            setEvent(response.data.event);
            setTickets(response.data.tickets);
            handleSettingTickets(response.data.tickets);
        }
        setIsLoading(false);
    }

    const handleSettingTickets = async (_tickets) => {
        let _sections = [];
        let _categories = [];
        if(_tickets !== undefined)
        {
            await Promise.all(_tickets.map(item =>{
                _sections.push({
                    evento_seccion_id: item.evento_seccion_id,
                    uuid:item.uuid,
                    nombre: item.nombre, //nombre de la categoria
                    descripcion: item.descripcion,
                    precio: item.precio,
                    cantidad: 0,
                    seleccion_max: item.seleccion_max,
                    evento_id: item.evento_id,
                    lista_asientos:[],
                    capacidad: item.capacidad,
                    vendidos: item.vendidos,
                    disponibles: parseInt(item.capacidad) - parseInt(item.vendidos),
                    mostrar_disp: item.mostrar_disp,
                    estatus: item.estatus
                });

                _categories.push({
                    category: item.nombre,
                    price: item.precio,
                    description: item.descripcion
                })
            }));

            setSections(_sections);
            setCategories(_categories);
        }
    }


     /**---------------------------------------------------------------
     *      GESTION DEL "CARRITO DE COMPRAS"                        |
     *--------------------------------------------------------------*/
     const handleShoppingCart = async (_uuid,_operator,_ticket) => {

        setSections((prevSections)=>{
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item)=> item.uuid === _uuid);

            if(indexToUpdate !== -1){
                let _cantidad = updatedSections[indexToUpdate].cantidad;
                
                if(_operator === '+')
                {
                    if(_cantidad < _ticket.disponibles && _cantidad < _ticket.seleccion_max)
                    _cantidad = _cantidad + 1;
                }
                else
                {
                    if(_cantidad > 0)
                    {
                        _cantidad = _cantidad - 1;
                    }
                }

                updatedSections[indexToUpdate].cantidad = _cantidad;
                
                let _lista_asientos = [];
                for(let i=0;i<_cantidad;i++)
                {
                    _lista_asientos.push({fil:updatedSections[indexToUpdate].nombre});
                }
                updatedSections[indexToUpdate].lista_asientos = _lista_asientos;
            }
            return updatedSections;
        })

    }




    const handleTotals = async () => {
        let _subtotal = 0;
        let _comision = 0;
        let _total = 0;
        let _comision_asientos = 0;

        await Promise.all(sections.map(item=>{
            if(event.event_key !== null)
            {
                _comision_asientos += item.cantidad*1;
            }
            return _subtotal += (item.cantidad * item.precio);
        }));

        _comision = parseFloat(_subtotal*(parseFloat(event.comision)/100));
        _total = parseFloat(_subtotal) + (_subtotal*(parseFloat(event.comision)/100));
        _total = _subtotal + _comision + _comision_asientos;

        console.log('TOTAL ASIENTOS ===> ',_comision_asientos);

        setSubTotal(_subtotal);
        setComision(_comision+_comision_asientos);
        setFee(_comision)
        setFeeSeats(_comision_asientos);
        setTotal(_total);
    }

    useEffect(()=>{
        handleTotals();

        let encontrado = false;
        for(let i=0; i<sections.length; i++)
        {
            if(sections[i].cantidad > 0)
            {
                setContinuar(true);
                encontrado = true;
                break;
            }
        }

        if(!encontrado)
            setContinuar(false);
        
        
    },[sections]);

    

    /**--------------------------------------------------
     * Para manejar el paso a paso                      |
     * ------------------------------------------------*/
    const handleNext = async () => {
        if(activeStep === 1)
        {
            if(formVerification() === 1)
                return;
        }

        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        /*if(userData.user === undefined)
            setActiveStep(1);
        else
            setActiveStep(2);*/

    };
    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const formVerification = () => {
        let ban = 0;
        if(name === '')
        {
            setNameError(true);
            ban=1;
        }
        if(lastName === '')
        {
            setLastNameError(true);
            ban = 1
        }
        if(event?.doc_obligatorio === 1 && document === '')
        {
            setDocumentError(true);
            ban=1;
        }
        if(phoneNumber.length < 11)
        {
            setPhoneNumberError(true);
            ban=1
        }
        if(email === '')
        {
            setEmailError(true);
            ban=1
        }

        if(event.id === 30 && profession === '')
        {
            setProfessionError(true);
            ban=1;
        }

        return ban;
    }




  
    const handleSubmit = async (paymentSuccess,payments,automatedPayment=false,paymentMessage='') => {

        let ban = await formVerification();
        if(ban === 1)
            return 

        if(paymentSuccess)
        {
            /**reservar los ticket aqui */


            /**Si el proceso es exitoso se continua el proceso,
             * si falla se hace un rollback en seats.io 
             * */
            
            setIsLoading(true);

            let document_type = '';
            if(event.doc_obligatorio === 1)
                document_type = documentType;

            const cliente = {
                nombre: name,
                apellido: lastName,
                nacimiento:  moment(birthDate).format('YYYY-MM-DD'),
                direccion: address,
                documento_tipo: document_type,
                documento: document,
                correo:email,
                prefijo:prefix,
                telefono: phoneNumber,
                profesion: profession + especialista
            };

            let id_usuario = null;
            if(userData.user !== undefined)
                id_usuario = userData.user.id;
        
            const id_comercio = event.merchant_uuid;
            //const monto = parseFloat(total);
            const monto = parseFloat(subtotal);
            const detalles = sections.filter(section => section.cantidad > 0) ;

            let pagos=[];
            if(payments !== null)
            {
                pagos = [
                    {
                        //uuid: payments.uuid,
                        //paymentMethod: payments.payment_method,
                        //accountName: payments.description,
                        amount: parseFloat(payments.monto),
                        reference: payments.referencia,
                        id_numero_cuenta: payments.id_numero_cuenta
                    }
                ];
            }
    

            let response = await BuyTickets(
                id_usuario,
                id_comercio,
                cliente,
                monto,
                comision,
                detalles,
                pagos,
                automatedPayment,
                holdToken,
                selectedSeats,
                event.event_key
            );
            
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccessA(true);
                setShow(true);

                setName('');
                setLastName('');
                setDocumentType('V')
                setDocument('')
                setEmail('');
                setPhoneNumber('');
                setAddress('');
            }
            else
            {
                setTitle('Operación Fallida! '+message.title);
                setMessage(response.message.message);
                setSuccessA(false);
                setShow(true);
            }
            
            setIsLoading(false);
        }
        else
        {
            setTitle('Operación Fallida!');
            setMessage(paymentMessage);
            setSuccessA(false);
            setShow(true);
        }
    }


    const handleOnClose = () => {
        setShowModal(false);
        console.log('LOCALSTORAGE ===> ',localStorage.getItem('UserAccount'))
        if(localStorage.getItem('UserAccount') === null)
        {
            setSuccessA(false);
            setTitle('Inicio de sesión obligatorio');
            setMessage('Para poder comprar boletos debe registrarse y/o iniciar sesión');
            setGoBack(true);
            setShow(true);
        }
    }

    const handleClostResponse = () => {
        if(goBack === true)
        {
            history.goBack();
        }
        else
        {
            if(successA === true){
                setShow(false);
                setActiveStep(0);
                
                redireccionar(`/digitel/${id}`);
                handleGetEvent()
            }
                
            else
                setShow(false);
        }
    }

    /*--------------------------------------------------------
    /*          Manejo de la seleccion de asientos           |
    /*------------------------------------------------------*/

    const handleSelectingSeat = async (selectedObject,_operator) => {
        setSections((prevSections)=>{
            const updatedSections = [...prevSections];
            const indexToUpdate = updatedSections.findIndex((item)=> item.nombre === selectedObject.category.label);
            
            if(indexToUpdate !== -1)
            {
                //let _cantidad = updatedSections[indexToUpdate].cantidad;

                if(_operator === '+')
                {
                    const seats = updatedSections[indexToUpdate].lista_asientos;

                    if(selectedObject.seats)
                    {
                        selectedObject.seats.map(item=>{
                            const [label,fil,col] = item.label.split('-');
                            const seatToFind = {fil: fil,col: col};
                            const seatFound = seats.find(seat=>seat.fil === seatToFind.fil && seat.col === seatToFind.col)
                    
                            if(!seatFound)
                                updatedSections[indexToUpdate].lista_asientos.push({
                                    fil:fil,col:col
                                });
                            return{
                                label,fil,col
                            }
                        });
                        
                        //console.log('selectedObject.seats ===> ',_listaAsientos)
                    }
                    else
                    {
                        const seatToFind = {fil: selectedObject.labels.parent,col: selectedObject.labels.own}
                    
                        const seatFound = seats.find(seat=>seat.fil === seatToFind.fil && seat.col === seatToFind.col)
                        
                        if(!seatFound)
                            updatedSections[indexToUpdate].lista_asientos.push({
                                fil:selectedObject.labels.parent,col:selectedObject.labels.own
                            });
                    }

                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;
                }
                else
                {
                    if(selectedObject.seats)
                    {
                        selectedObject.seats.map(item=>{
                            const [label,fil,col] = item.label.split('-');
                            //const seatFound = seats.find(seat=>seat.fil === seatToFind.fil && seat.col === seatToFind.col)
                            let _asientos = updatedSections[indexToUpdate].lista_asientos.filter(item=>!(item.fil === fil && item.col === col))
                            updatedSections[indexToUpdate].lista_asientos = _asientos;
                            
                            return{
                                label,fil,col
                            }
                        });
                    }
                    else
                    {
                        //se filtran los asientos para eliminar el objeto anterior
                        let _asientos = updatedSections[indexToUpdate].lista_asientos.filter(item=>!(item.fil === selectedObject.labels.parent && item.col === selectedObject.labels.own))
                        updatedSections[indexToUpdate].lista_asientos = _asientos;
                    }
                        
                    updatedSections[indexToUpdate].cantidad = updatedSections[indexToUpdate].lista_asientos.length;   
                }

                /*updatedSections[indexToUpdate].cantidad = _cantidad;
                updatedSections[indexToUpdate].lista_asientos.push({
                    fil:selectedObject.labels.parent,col:selectedObject.labels.own
                });*/
            }
            //console.log('LA SELECCION ES ===> ',updatedSections);
            return updatedSections;
        })
    }



    const handleGoBack = () => {
        if(activeStep === 1)
            handleSettingTickets(tickets)

        setActiveStep(activeStep - 1);
    }

    const pricingWithDescriptions = categories.map(category => ({
        category: category.category, // Identificador de la categoría
        price: category.price,
        description: category.description || '', // Agrega la descripción aquí
    }));


    const handleOnChangeRecaptcha = (value) => {
        setReCaptcha(value)
    }

    const handleOnExpiredRecaptcha = () => {
        setReCaptcha('')
    }


    return(
        <Box mt={-5} pb={5}>
            {/*<SignInModal
                open={showModal}
                onClose={()=>handleOnClose()}
            />*/}
            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={show}
                success={successA}
                title={title}
                message={message}
                actionText={'Aceptar'}
                onClick={()=>handleClostResponse()}
            />
            
            <Container>
                <Grid container spacing={3} mt={5}>
                    
                    <Grid item xs={12} sm={12} md={4} lg={5} xl={5} mt={5} display={'flex'} justifyContent={'center'}>
                        <Box style={{ width:'80%' }}>
                            <img
                                style={{width:'100%'}}
                                src={logoDigitel}
                                alt={event.nombre}
                            />
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12} sm={12} md={8} lg={7} xl={7}>
                        {
                            activeStep > 0 &&
                            <IconButton onClick={()=>handleGoBack()}>
                                <FontAwesomeIcon icon={faArrowLeft}/>
                            </IconButton>
                        }

                        <CountdownComponent refreshTime={600000} />
                        <Typography variant="h5" fontWeight={'bold'}>{event.nombre}</Typography>
                        {
                            activeStep === 0 &&
                            <> 
                                <Typography sx={{fontSize:18,color:'#4d2680',fontWeight:'bold'}} variant="body1" >
                                    Tu oportunidad de ganar comienza aquí: ¡selecciona una categoría!
                                </Typography>
                                {
                                    sections.length !== 0 &&
                                    sections.map((item)=>{
                                        let borderColor='#FFF';
                                        let bgColor='#FFF';
                                        
                                        if(item.cantidad > 0)
                                        {
                                            borderColor = 'success.dark' //lightTheme.colors.success.dark;
                                            bgColor = 'success.lightTransparency' //lightTheme.colors.success.lightTransparency;
                                        }
                                        return(
                                            <Paper
                                                elevation={3}
                                                sx={{mt:2,borderColor:borderColor,bgcolor:bgColor, '&:hover':{cursor:"pointer"}}}
                                                onClick={()=>{handleShoppingCart(item.uuid,'+',item);handleNext()} }
                                            >
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
                                                        <Typography variant="h6" fontWeight={'bold'}>
                                                            {item.nombre}
                                                        </Typography>
                                                        <Typography variant="body1">
                                                            {item.descripcion}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        )
                                    })
                                }
                            </>
                        }


                        {/**Datos Personales */}
                        {
                            activeStep === 1 &&
                            <>
                                <Grid container spacing={3} mt={3}>
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Typography variant='h6'>Información personal</Typography>
                                        <Divider/>
                                    </Grid>
                                    {/**Nombre */}
                                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                        <TextField
                                            fullWidth
                                            id="name"
                                            name="name"
                                            label="Nombre"
                                            value={name}
                                            onChange={(e)=>setName(e.target.value)}
                                            onBlur={ () => (setNameError(name===''?true:false)) }
                                            error = {nameError}
                                            helperText={nameError && 'Ingrese el nombre'}
                                        />
                                    </Grid>

                                    {/*Apellido*/}
                                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                                        <TextField
                                            fullWidth
                                            id="lastName"
                                            name="lastName"
                                            label="Apellido"
                                            value={lastName}
                                            onChange={(e)=>setLastName(e.target.value)}
                                            onBlur={ () => (setLastNameError(lastName===''?true:false)) }
                                            error = {lastNameError}
                                            helperText={lastNameError && 'Ingrese el apellido'}
                                        />
                                    </Grid>

                                    {/**Fecha nacimiento*/}
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <LocalizationProvider dateAdapter={AdapterMoment}>
                                            <DatePicker
                                                label="Fecha de nacimiento"
                                                value={birthDate}
                                                onChange={(newValue) => setBirthDate(newValue) }
                                                renderInput={(params) => <TextField fullWidth {...params} />}
                                            />
                                        </LocalizationProvider>
                                    </Grid>


                                    
                                    {
                                        event.doc_obligatorio === 1 &&
                                        <>
                                            <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <TextField
                                                    fullWidth
                                                    id="documentType"
                                                    name="documentType"
                                                    label="Documento"
                                                    select
                                                    value={documentType}
                                                    onChange={(e)=>setDocumentType(e.target.value)}
                                                >
                                                    <MenuItem value='V'>V</MenuItem>
                                                    <MenuItem value='E'>E</MenuItem>
                                                </TextField>
                                            </Grid>
                                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                                <TextField
                                                    fullWidth
                                                    id="documentNumber"
                                                    name="documentNumber"
                                                    label="Número de documento"
                                                    value={document}
                                                    onChange={(e)=>setDocument(e.target.value)}
                                                    onBlur={ () => (setDocumentError(document===''?true:false)) }
                                                    error = {documentError}
                                                    helperText={documentError && 'Ingrese el número de documento'}
                                                />
                                            </Grid>
                                        </>
                                    }
                                    

                                    {/**Telefono */}
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <PhoneInput
                                            country={event.pais_simbolo}
                                            specialLabel="Número de Teléfono"
                                            inputStyle={{width:'100%'}}
                                            value={phoneNumber}
                                            onChange={(e)=>setPhoneNumber(e)} // passed function receives the phone value
                                            onBlur={ () =>  (setPhoneNumberError(phoneNumber.length < 11?true:false)) }
                                        />
                                        {
                                            phoneNumberError &&
                                            <Typography variant="caption" color={'error.main'}>El número de teléfono es inválido</Typography>
                                        }
                                    </Grid>

                                     {/**Ciudad */}
                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <TextField
                                            fullWidth
                                            id="address"
                                            name="address"
                                            label="Ciudad"
                                            value={address}
                                            onChange={(e)=>setAddress(e.target.value)}
                                            //onBlur={ () => (setNameError(name===''?true:false)) }
                                            //error = {nameError}
                                            helperText={nameError && 'Ingrese la ciudad'}
                                        />
                                    </Grid>


                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <TextField
                                            fullWidth
                                            id="email"
                                            name="email"
                                            label="Correo electrónico"
                                            value={email}
                                            onChange={(e)=>setEmail(e.target.value)}
                                            onBlur={ () => (setEmailError(email===''?true:false)) }
                                            error = {emailError}
                                            helperText={emailError && 'Ingrese el correo electrónico'}
                                        />
                                    </Grid>
                                    
                                    {
                                        event.categoria_evento === "Salud" &&
                                        <>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <TextField
                                                    fullWidth
                                                    id="profession"
                                                    name="profession"
                                                    label="Nivel Profesional"
                                                    select
                                                    value={profession}
                                                    onChange={(e)=>setProfession(e.target.value)}
                                                    onBlur={ () => (setProfessionError(profession===''?true:false)) }
                                                    error = {professionError}
                                                    helperText={professionError && 'Seleccione su nivel profesional'}
                                                >
                                                    <MenuItem value='Médico General'>Médico General</MenuItem>
                                                    <MenuItem value='Médico Especialista - '>Médico Especialista</MenuItem>
                                                    <MenuItem value='Médico Residente'>Médico Residente</MenuItem>
                                                    <MenuItem value='Estudiante'>Estudiante</MenuItem>
                                                    <MenuItem value='Otro - '>Otro</MenuItem>
                                                </TextField>
                                            </Grid>
                                            {
                                                (profession === "Médico Especialista - " || profession === "Otro - ") &&
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="especialista"
                                                        name="especialista"
                                                        label="Especialidad u otra profesión"
                                                        value={especialista}
                                                        onChange={(e)=>setEspecialista(e.target.value)}
                                                        //onBlur={ () => (setEmailError(email===''?true:false)) }
                                                        //error = {emailError}
                                                        helperText={emailError && 'Ingrese su área de especialización'}
                                                    />
                                                </Grid>
                                            }
                                        </>
                                    }

                                    {
                                        event.pais === "Colombia" &&
                                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <Typography>
                                                En cumplimiento de la Ley 1581 de 2012, "Por la cual se dictan disposiciones generales para la protección de datos personales", y su Decreto Reglamentario 1.377 de 2013, solicitamos su autorización para el tratamiento (recolección, almacenamiento, uso y circulación a terceros) de los datos obtenidos a través de esta herramienta de registro y compra. Al hacer clic en el botón "Continuar", usted nos autoriza a utilizar sus datos conforme a las disposiciones mencionadas.
                                            </Typography>
                                        </Grid>
                                    }

                                    {/*<ReCaptchaGoogle
                                        onChange={handleOnChangeRecaptcha}
                                        onAbort={handleOnExpiredRecaptcha}
                                        onExpired={handleOnExpiredRecaptcha}
                                    />*/}
                                    

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            //disabled={reCaptcha===''}
                                            fullWidth
                                            variant="contained"
                                            onClick={()=>handleSubmit(true,null,true)}
                                        >
                                            <Typography>Participar</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        }

                       
                        
                    </Grid>
                </Grid>
                
            </Container>
            {
                (continuar === true && activeStep === 0)&&
                <Box
                    onClick={()=>handleNext()}
                    role="presentation"
                    sx={{ position: 'fixed', bottom: 16, right: 16 }}
                >
                    <Fab variant="extended" sx={{bgcolor:'primary.main',color:'primary.contrastText'}}>
                        <FontAwesomeIcon icon={faTicket}/>&nbsp;
                        {event.id === 30 ?"Obtener Boletos":"Comprar Boletos"}
                    </Fab>
                </Box>
            }
        </Box>
    )
}